import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const HTML = () => {
  return (
    <StartInterviewLayout type="html" />
  )
}

export default HTML